import e from"react";import{Checkbox as t}from"./styles.js";const r=({selected:r,text:s,testId:a,...c})=>e.createElement("li",{...c},e.createElement(t,{checked:r,"data-testid":a}),s);export{r as default};
//# sourceMappingURL=Option.js.map
